// The app's one disclosure mark, an open chevron (the select chevron in
// ActionControls.module.css), never a filled triangle. It points down while closed and up
// while open; ``tree`` points it right while closed and down while open, for rows that
// expand in place. Inside a <summary> it turns with its <details> through CSS, so leave
// ``open`` unset there.
import styles from "./Chevron.module.css";

export const Chevron = ({
  open = false,
  tree = false,
}: {
  open?: boolean;
  tree?: boolean;
}) => (
  <svg
    className={`${styles.chevron} ${tree ? styles.tree : ""} ${open ? styles.open : ""}`}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    aria-hidden="true"
  >
    <path
      d="M1 1l4 4 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
